import {
  BooleanVariableDTO,
  ListVariableDTO,
  NumberVariableDTO,
  StringVariableDTO,
  VariableDTO,
} from 'jobs/dtos/variables'
import { roundToPrecision } from 'utils/number-util'
import { DEFAULT, match } from 'utils/pattern-match-util'

/**
 * Variable view model base.
 */
abstract class VariableViewModelBase<T extends VariableDTO> {
  /**
   * Variable ID.
   */
  id = ''
  /**
   * The variable label.
   */
  label = ''
  /**
   * The value of the variable.
   */
  value: T['value'] = null as any
  /**
   * The type of value for the variable.
   */
  valueType: T['valueType'] = null as any

  hydrateDTO(dto: T) {
    this.id = dto.id
    this.label = dto.label
    this.value = dto.value
    this.valueType = dto.valueType
  }
}

export class BooleanVariableViewModel extends VariableViewModelBase<BooleanVariableDTO> {
  get textValue() {
    return this.value ? 'Yes' : 'No'
  }
}

export class StringVariableViewModel extends VariableViewModelBase<StringVariableDTO> {
  get textValue() {
    return this.value
  }
}

export class NumberVariableViewModel extends VariableViewModelBase<NumberVariableDTO> {
  get textValue() {
    if (this.value !== undefined) {
      return roundToPrecision(this.value, 2)
    }
  }
}

export class ListVariableViewModel extends VariableViewModelBase<ListVariableDTO> {
  get textValue() {
    const type = this.valueType.itemType.type

    return match(type, {
      Boolean: () => this.value?.map((i) => (i ? 'Yes' : 'No')).join(', '),
      String: () => this.value?.join(', '),
      Number: () => this.value?.join(', '),
      [DEFAULT]: () => this.value,
    })
  }
}

export class UnknownVariableViewModel extends VariableViewModelBase<any> {
  get textValue(): string {
    return this.value
  }

  public hydrateDTO(_: unknown) {
    this.id = 'UNKNOWN'
    this.value = 'UNKNOWN'
  }
}

/**
 * Variables view models.
 */
export type VariableViewModel =
  | BooleanVariableViewModel
  | StringVariableViewModel
  | NumberVariableViewModel
  | ListVariableViewModel
